import { useState } from "react";
import { Container, Navbar, Offcanvas, Nav } from "react-bootstrap";
import { FaUserCircle } from "react-icons/fa";
import { IoChevronDown } from "react-icons/io5";
import { NavLink, useNavigate } from "react-router-dom";


const Header = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [accountOpen, setAccountOpen] = useState(false);

  const userEmail = localStorage.getItem("userEmail");
  const isVerified = localStorage.getItem("isVerified");

  const toggleMenu = () => setOpen(!open);
  const toggleAccount = () => setAccountOpen(!accountOpen);


  const handleLogout = () => {
    localStorage.clear(); // or remove only the required keys

    setAccountOpen(false);
    setOpen(false);

    navigate("/home", { replace: true });
  };


  return (
    <div className="container">

    <header className="header-section z-50 backdrop-blur-xl bg-white/20 border-b border-white/30">

        <Navbar
          expand="lg"
          className="py-2 flex items-center justify-between">

          {/* Logo */}
          <Navbar.Brand href="/home">
            <img
              src="../gosehari-logo.png"
              alt="logo"
              className="h-12 sm:h-14 md:h-16 lg:h-20 w-auto object-contain"
            />
          </Navbar.Brand>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 rounded-md hover:bg-gray-100 transition"
            onClick={toggleMenu}
          >
            ☰
          </button>

          {/* Offcanvas Mobile Menu */}
          <Offcanvas
            show={open}
            onHide={toggleMenu}
            placement="start"
            className="w-[85%] sm:w-80"
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title>Go Sehari</Offcanvas.Title>
            </Offcanvas.Header>

            <Offcanvas.Body>

              <Nav className="flex flex-col gap-4">

                <NavLink to="/tours-details" onClick={toggleMenu}>
                  Tours
                </NavLink>

                <NavLink to="/attractions" onClick={toggleMenu}>
                  Attractions
                </NavLink>

                <NavLink to="/" onClick={toggleMenu}>
                  Hotels
                </NavLink>

                <NavLink to="/" onClick={toggleMenu}>
                  Transport
                </NavLink>

                <NavLink to="/" onClick={toggleMenu}>
                  Plan My Trip
                </NavLink>

                <NavLink to="/" onClick={toggleMenu}>
                  Gallery
                </NavLink>

                <NavLink to="/" onClick={toggleMenu}>
                  About
                </NavLink>

                <NavLink to="/" onClick={toggleMenu}>
                  Contact
                </NavLink>

                {/* Mobile Account */}
                <div className="border-t pt-3 mt-3">

                  {!isVerified ? (
                    <>
                      <NavLink to="/login">Login</NavLink>
                    </>
                  ) : (
                    <>
                      <p className="text-gray-500 mb-2">
                        {userEmail}
                      </p>

                      <NavLink to="/my-trips">
                        My Trips
                      </NavLink>

                      <button
                        onClick={handleLogout}
                        className="text-left text-red-500 hover:text-red-600"
                      >
                        Logout
                      </button>
                    </>
                  )}

                </div>

              </Nav>

            </Offcanvas.Body>
          </Offcanvas>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center gap-4 xl:gap-6 ml-auto">

            <NavLink to="/tours-details">Tours</NavLink>
            <NavLink to="/attractions">Attractions</NavLink>
            <NavLink to="/">Hotels</NavLink>
            <NavLink to="/">Transport</NavLink>
            <NavLink to="/">Plan Trip</NavLink>
            <NavLink to="/">Gallery</NavLink>
            <NavLink to="/">About</NavLink>
            <NavLink to="/">Contact</NavLink>

            {/* Account Dropdown */}
            <div className="relative">

              <div
                onClick={toggleAccount}
                className="flex items-center gap-2 cursor-pointer px-3 py-2 rounded-lg hover:bg-gray-100"
              >
                <span>
                  {!isVerified ? (
                    <NavLink to="/login" className="flex items-center gap-2">
                      <FaUserCircle />
                      <span>Guest</span>
                    </NavLink>
                  ) : (
                    <div
                      onClick={toggleAccount}
                      className="flex items-center gap-2 cursor-pointer px-3 py-2 rounded-lg hover:bg-gray-100"
                    >
                      <FaUserCircle />
                      <span className="hidden xl:block max-w-[180px] truncate">
                        {userEmail}
                      </span>
                      <IoChevronDown />
                    </div>
                  )}
                </span>
              </div>

              {accountOpen && (
                <div className="absolute right-0 mt-2 w-64 max-w-[90vw] bg-white rounded-xl border shadow-xl overflow-hidden z-50">
                  {!isVerified ? (
                    <>
                      <NavLink
                        to="/login"
                        className="block px-4 py-3 hover:bg-gray-100"
                      >
                        Login
                      </NavLink>

                      <NavLink
                        onClick={handleLogout}
                        className="block px-4 py-3 hover:bg-gray-100"
                      >
                        Logout
                      </NavLink>
                    </>

                  ) : (
                    <>
                      <div className="px-4 py-3 border-b text-gray-500 truncate">
                        {userEmail}
                      </div>

                      <NavLink
                        to="/my-trips"
                        className="block px-4 py-3 hover:bg-gray-100"
                      >
                        My Trips
                      </NavLink>

                      <button
                        onClick={handleLogout}
                        className="block w-full text-left px-4 py-3 hover:bg-gray-100 text-red-500"
                      >
                        Logout
                      </button>
                    </>
                  )}

                </div>
              )}

            </div>
          </div>
        </Navbar>
    </header>
    </div>

  );
};

export default Header;